import { useState, useEffect } from 'react';

import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import { logout } from '@/features/login/api/logout';

interface User {
  avatar?: string;
  token?: string;
  workspaceId?: string;
  userId?: string;
  role?: string;
  type?: string;
  name?: string;
  workspace?: {
    name?: string;
  };
}

interface Session {
  user: User;
  expires: string;
}

export const useSession = () => {
  const router = useRouter();
  const [session, setSession] = useState<Session | null>(null);
  const [status, setStatus] = useState('unauthenticated');
  const [isLoading, setIsLoading] = useState(true);

  const update = (user: User) => {
    const newSession = { ...session, user: { ...session.user, ...user } };
    Cookies.set('token', JSON.stringify(newSession));
    setSession(newSession);
  };

  const signOut = async () => {
    const token = Cookies.get('token')
    if (!token) {
      return;
    }
    await logout(token);

    Cookies.remove('token');
    setSession(null);
    setStatus('unauthenticated');
    router.push('/');
  };

  useEffect(() => {
    const sessionRaw = Cookies.get('token');
    if (sessionRaw) {
      const session = JSON.parse(sessionRaw);
      const token = session?.user?.token;
      if (!token) {
        setStatus('unauthenticated');
      } else {
        setSession(session);
        setStatus('authenticated');
      }
    } else {
      setSession(null);
    }

    setIsLoading(false); // Set isLoading to false after fetching session data
  }, []);

  return { data: session, isLoading, status, update, signOut };
};
